module.exports = __webpack_public_path__ + "460c52ba7815c430e67972215fe4c2cf.svg";